import React, { useRef, useState } from 'react';
import PortalModal from '../../../Common/Modal/PortalModal';
import { useCapsuleConfigurator } from '../../../../context/CapsuleConfiguratorContext';

const UpdateMultipleCapsuleModal = React.forwardRef(({ capsulesDropdownOptions, selection, updateBatchCapsule }, ref) => {
    const { setConfigurationSelection } = useCapsuleConfigurator();
    const [selectedCapsule, setSelectedCapsule] = useState(capsulesDropdownOptions[0].id)
    const handleAssignMultipleCapsule = () => {
        const capsule = capsulesDropdownOptions.find(capsule => capsule.id === selectedCapsule);
        updateBatchCapsule(Object.keys(selection).map(Number), capsule);
        setConfigurationSelection({});
        ref?.current.hideModal()
    };

    return (
        <PortalModal ref={ref}>
            <div className='p-4 gap-4 flex flex-col items-center'>
                <h1 className='text-lg font-bold'>Assigner une Capsule à la sélection</h1>
                <select value={selectedCapsule} className='select select-bordered select-primary w-full max-w-xs' onChange={(e) => setSelectedCapsule(parseInt(e.target.value))}>
                    {capsulesDropdownOptions.map((option) => (
                        <option key={option.id} value={option.id}>{option.name}</option>
                    ))}
                </select>
                <div className='flex gap-4'>
                    <button onClick={handleAssignMultipleCapsule} className='btn btn-primary'>Assigner</button>
                    <button onClick={() => ref.current?.hideModal()} className='btn btn-error'>Annuler</button>
                </div>
            </div>
        </PortalModal>
    );
});

export default UpdateMultipleCapsuleModal;
